import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ClarityModule } from '@clr/angular';
import { ChannelEnginePanelComponent } from '../channel-engine-panel/channel-engine-panel.component';
import { EnvironmentControlPanelComponent } from '../environment-control-panel/environment-control-panel.component';

type DashboardTab = 'channels' | 'environment';

/**
 * Admin-Dashboard: Rahmen um zwei Tabs.
 *
 * 2026-09-07 — die Seite war seit "ut-115: UI: dashboard => programmplan" ein
 * leerer Platzhalter. Sie beherbergt jetzt die beiden Betriebseinstellungen,
 * die nirgends sonst hingehören: die primäre Live-Transkription pro Sender und
 * die Umgebungssteuerung.
 *
 * Statisches Clarity-Tab-Markup statt <clr-tabs> (wie auf der Statistikseite),
 * damit beide Panels instanziiert bleiben — das Umgebungs-Panel pollt seinen
 * Status und soll beim Tabwechsel nicht bei null anfangen.
 */
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, ClarityModule, ChannelEnginePanelComponent, EnvironmentControlPanelComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardComponent {

  activeTab: DashboardTab = 'channels';

  selectTab(tab: DashboardTab): void {
    this.activeTab = tab;
  }
}
